import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DidsWithLabel } from '../../../account/store/states-models';

@Component({
  selector: 'outbound-did-select',
  templateUrl: './outbound-did-select.component.html',
  styleUrls: ['./outbound-did-select.component.scss']
})
export class OutboundDidSelectComponent {
  @Input() currentDid: DidsWithLabel = { label: '', number: '' };
  @Input() dids: DidsWithLabel[] = [];
  @Input() loading: boolean = false;
  @Input() loadFailed: boolean = false;
  @Input() callFromLabel: string = '';
  @Input() menuMinWidth: string = 'auto';
  @Output() didSelected = new EventEmitter<DidsWithLabel>();
  @Output() retry = new EventEmitter<void>();
}